import { customAttribute, inject, bindable } from 'aurelia-framework';
import 'jquery';

@customAttribute('tooltip')
@inject(Element)
export class Tooltip {
    element: HTMLElement;
    @bindable title: any;
    @bindable placement: any = "bottom";

    constructor(element) {
        this.element = element;
    }

    attached() {
        let $: any = window["jQuery"];

        $(this.element).tooltip({
            title: this.title || this["value"],
            placement: this.placement
        });
    }

    valueChanged(newValue) {
        let $: any = window["jQuery"];
        $(this.element).tooltip({
            title: newValue,
            placement: this.placement
        });
    }
    titleChanged(newValue) {
        let $: any = window["jQuery"];
        $(this.element).tooltip({
            title: newValue,
            placement: this.placement
        });
    }
}